export function formatChatDate(value) {
    let date = parseChatDate(value);
    if (date == null) return '';
    return date.toLocaleString();
}

function parseChatDate(value) {
    if (value == null || value === '') return null;

    if (Array.isArray(value)) {
        let year = value[0];
        let month = value[1];
        let day = value[2];
        if (year == null || month == null || day == null) return null;
        return normalizeDate(new Date(
            year,
            month - 1,
            day,
            value[3] || 0,
            value[4] || 0,
            value[5] || 0,
            Math.floor((value[6] || 0) / 1000000)
        ));
    }

    if (typeof value === 'number') {
        return parseTimestamp(value);
    }

    let textValue = ('' + value).trim();
    if (textValue.length === 0) return null;

    if (/^\d+$/.test(textValue)) {
        return parseTimestamp(Number(textValue));
    }

    let parsedDate = normalizeDate(new Date(textValue));
    if (parsedDate != null && parsedDate.getFullYear() > 2000) return parsedDate;

    let localDateMatch = textValue.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/);
    if (localDateMatch == null) return parsedDate;

    return normalizeDate(new Date(
        Number(localDateMatch[1]),
        Number(localDateMatch[2]) - 1,
        Number(localDateMatch[3]),
        Number(localDateMatch[4] || 0),
        Number(localDateMatch[5] || 0),
        Number(localDateMatch[6] || 0)
    ));
}

function parseTimestamp(value) {
    if (!isFinite(value)) return null;
    let timestamp = value < 100000000000 ? value * 1000 : value;
    return normalizeDate(new Date(timestamp));
}

function normalizeDate(date) {
    if (date == null || isNaN(date.getTime())) return null;
    return date;
}



// WEBPACK FOOTER //
// ./src/components/Chat/ChatDateUtils.js